/** Question validation type for SSN (matches backend / course builder) */
export const SSN_VALIDATION = 5;

/** US SSN: AAA-GG-SSSS with standard area/group/serial exclusions */
const SSN_PATTERN = /^(?!000|666|9\d\d)\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/;

export function isSsnQuestion(quest) {
  return quest != null && Number(quest.validation) === SSN_VALIDATION;
}

/** True when the form includes at least one SSN question */
export function hasSsnQuestions(questions) {
  if (!questions || !questions.length) {
    return false;
  }
  return questions.some(isSsnQuestion);
}

export function isValidSSN(ssn) {
  const value = (ssn || "").trim();
  if (!value) {
    return false;
  }
  return SSN_PATTERN.test(value);
}

export function formatSSN(value) {
  const x = (value || "")
    .replace(/\D/g, "")
    .match(/(\d{0,3})(\d{0,2})(\d{0,4})/);
  return !x[2] ? x[1] : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
}

export function getSsnFieldError(ssn) {
  const value = (ssn || "").trim();
  if (!value) {
    return "Please enter a valid SSN.";
  }
  if (value.length < 11) {
    return "Enter complete SSN (XXX-XX-XXXX).";
  }
  if (!isValidSSN(value)) {
    return "Invalid SSN.";
  }
  return "";
}

/**
 * True only when an SSN question exists and is empty or invalid.
 * Courses with no SSN questions always return false (user can continue).
 */
export function hasUnresolvedSsnQuestions(questions) {
  if (!hasSsnQuestions(questions)) {
    return false;
  }
  return questions.some(
    (quest) => isSsnQuestion(quest) && !isValidSSN(quest.selected_answers)
  );
}
